import { render, staticRenderFns } from "./FavLocationForm.vue?vue&type=template&id=598a2f9a&scoped=true"
import script from "./FavLocationForm.vue?vue&type=script&lang=ts"
export * from "./FavLocationForm.vue?vue&type=script&lang=ts"
import style0 from "./FavLocationForm.vue?vue&type=style&index=0&id=598a2f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a2f9a",
  null
  
)

export default component.exports